import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

import ResearchThemeButtonGroup from '../../molecules/ResearchThemeButtonGroup'
import ResearchCards from '../../organisms/ResearchCards'
import ResearchTimePeriodSelector from '../../molecules/ResearchTimePeriodSelector'
import CollapsibleStep from '../../atoms/CollapsibleStep'
import ResearchSelectedTerritoriesList from '../../organisms/ResearchSelectedTerritoriesList'
import ResearchResult from '../../molecules/ResearchResult'
import ResearchLandTenureCards from '../ResearchLandTenureCards/ResearchLandTenureCards'

const ResearchCollapsibleItem = styled(CollapsibleStep)`
  margin-bottom: 32px;
`

const Message = styled.span`
  color: ${({ theme }) => theme.colors.text.gray };
  font-size: 1.75rem;
`

export default class AgriculturalStudies extends React.PureComponent {
  state = {
    isStep1Open: true,
    isStep2Open: false,
    isStep3Open: false,
    isStep4Open: false
  }

  renderChooseAThemeMessage() {
    return (
      <FormattedMessage
        id="survey.messages.no_theme_selected"
      >
        {(text) => (
          <Message>
            { text }
          </Message>
        )}
      </FormattedMessage>
    )
  }

  renderIfThemeIsSelected(element, elmFundiario) {
    if (this.props.selectedTheme.id && this.props.selectedTheme.name !== "FUNDIARIO") {
      return element
    } 
    else if(this.props.selectedTheme.name == "FUNDIARIO") {
      return elmFundiario !== undefined ? elmFundiario : element;
    }
    else {
      return this.renderChooseAThemeMessage()
    }
  }

  render() {
    return (
      <div>

        <FormattedMessage
          id="survey.messages.theme_collapse"
        >
          {(text) => (
            <ResearchCollapsibleItem
              collapsed={ this.props.isCollapse1Collapsed }
              onChange={ this.props.onCollapse1Change }
              title={ text }
              step="1"
            >
              <ResearchThemeButtonGroup
                themes={ this.props.themes }
              />
            </ResearchCollapsibleItem>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="survey.messages.products_collapse"
        >
          {(text) => (
            <ResearchCollapsibleItem
              collapsed={ this.props.isCollapse2Collapsed }
              onChange={ this.props.onCollapse2Change }
              title={ text }
              step="2"
            >
              { this.renderIfThemeIsSelected(
                <ResearchCards
                  selectedTheme={ this.props.selectedTheme }
                  themes={ this.props.themes }
                />,
                <ResearchLandTenureCards />
              ) }
            </ResearchCollapsibleItem>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="survey.messages.territories_collapse"
        >
          {(text) => (
            <ResearchCollapsibleItem
              collapsed={ this.props.isCollapse3Collapsed }
              onChange={ this.props.onCollapse3Change }
              title={ text }
              step="3"
            >
              { this.renderIfThemeIsSelected(
                <React.Fragment>
                  <ResearchSelectedTerritoriesList />
                </React.Fragment>
              ) }
            </ResearchCollapsibleItem>
          )}
        </FormattedMessage>
        <FormattedMessage
          id="survey.messages.period_collapse"
        >
          {(text) => (
            <ResearchCollapsibleItem
              collapsed={ this.props.isCollapse4Collapsed }
              onChange={ this.props.onCollapse4Change }
              title={ text }
              step="4"
            >
              { this.renderIfThemeIsSelected(
                <ResearchTimePeriodSelector />
              ) }
            </ResearchCollapsibleItem>
          )}
        </FormattedMessage>
        <ResearchResult themes={ this.props.themes } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/AgriculturalStudies/AgriculturalStudies.js